module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_lp-data__voice01-d728a02e7639af1813ff24dcaccec2b7.png";